import React from "react";
import PropTypes from "prop-types";

import { Fieldset, Field, Control, Label, Input } from "rbx";

import {
  BooleanInput,
  CurrencySelect,
  ImageUploader,
  PhoneNumberInput,
  StateSelect,
  SystemCodeSelect,
  ZipCodeInput
} from "../inputs";

const CompanyInfoForm = ({ disabled, inputs, onChange }) => {
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    onChange(e.target.name, value);
  };
  return (
    <Fieldset disabled={disabled}>
      <Field kind="group">
        <Field>
          <Control>
            <Label>Image</Label>
            <ImageUploader
              name="ImageUrl"
              value={inputs.ImageUrl}
              onChange={handleChange}
            />
          </Control>
        </Field>
        <Field>
          <Field>
            <Control expanded>
              <Label>Name</Label>
              <Input
                autocomplete="new"
                name="Name"
                type="text"
                value={inputs.Name}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field multiline kind="group">
            <Control expanded>
              <Label>Address 1</Label>
              <Input
                autocomplete="new"
                name="Address1"
                type="text"
                value={inputs.Address1}
                onChange={handleChange}
              />
            </Control>
            <Control expanded>
              <Label>Address 2</Label>
              <Input
                autocomplete="new"
                name="Address2"
                type="text"
                value={inputs.Address2}
                onChange={handleChange}
              />
            </Control>
            <Control>
              <Label>City</Label>
              <Input
                autocomplete="new"
                name="City"
                type="text"
                value={inputs.City}
                onChange={handleChange}
              />
            </Control>
            <Control expanded>
              <Label>State</Label>
              <StateSelect
                name="State"
                size=""
                value={inputs.State}
                onChange={handleChange}
              />
            </Control>
            <Control>
              <Label>Zip Code</Label>
              <ZipCodeInput
                name="ZipCode"
                value={inputs.ZipCode}
                onChange={handleChange}
              />
            </Control>
            <Control expanded>
              <Label>Country</Label>
              <Input
                autocomplete="new"
                name="Country"
                type="text"
                value={inputs.Country}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Field>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Phone No</Label>
          <PhoneNumberInput
            name="PhoneNo"
            value={inputs.PhoneNo}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Fax No</Label>
          <PhoneNumberInput
            name="FaxNo"
            value={inputs.FaxNo}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="globe"
            label="Time Zone"
            lookup={{ Category: "Company", Code: "Time Zone" }}
            name="TimeZoneRecIdRef"
            size=""
            value={inputs.TimeZoneRecIdRef}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Website</Label>
          <Input
            autocomplete="new"
            name="Website"
            pattern="https://.*"
            size="30"
            type="url"
            value={inputs.Website}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <CurrencySelect
            label="Currency"
            name="Currency"
            value={inputs.Currency}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>
    </Fieldset>
  );
};

CompanyInfoForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
export default CompanyInfoForm;
